var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V9",
    transform: "translate(6 14)",
    stroke: "#1E334E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V13",
    transform: "translate(10.5 10)",
    stroke: "#1E334E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V8.5",
    transform: "translate(15.5 14.5)",
    stroke: "#1E334E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17",
    transform: "translate(19.5 6)",
    stroke: "#1E334E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5L5.5 3.5L10.5 7.5L14 0",
    transform: "translate(5 3)",
    stroke: "#1E334E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z",
    transform: "translate(18 1)",
    fill: "#F7931E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z",
    transform: "translate(9 5)",
    fill: "#F7931E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z",
    transform: "translate(14 9)",
    fill: "#F7931E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z",
    transform: "translate(4 10)",
    fill: "#F7931E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiIcon);
export default __webpack_public_path__ + "static/media/KPI_Icon.13942a96291987672f495605b0e9e401.svg";
export { ForwardRef as ReactComponent };